import React, { useEffect } from 'react'
import { PaletteMode } from '@mui/material'
import { ThemeProvider, createTheme } from '@mui/material/styles';

const ColorModeContext = React.createContext({ toggleColorMode: () => {} });

export default  ColorModeContext

const themeMode = localStorage.getItem('themeMode')?
  localStorage.getItem('themeMode') as PaletteMode : 'dark'

type Props = {
  children?: React.ReactNode;
}

export const ColorModeProvider = ({children}: Props) => {
  const [mode, setMode] = React.useState<PaletteMode>(themeMode);
  
  const colorMode = React.useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
      },
    }),
    [],
  );

  const theme = React.useMemo(
    () =>
      createTheme({
        palette: {
          mode,
        },
      }),
    [mode],
  );

  useEffect(() => {
    localStorage.setItem('themeMode', mode)
  }, [mode])

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        {children}
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}
